import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Trans } from '@lingui/macro';

import styled from 'styled-components';
import { SelectWrapper, TextFieldWrapper } from '@lib/final-form-oca-ui';
import { FileUploaderField } from '@features/common';
import { DocumentCard, IndexBadge } from './document-card';

export function FieldsetEducation({ options, name, index, onDelete }) {
  return (
    <DocumentCard
      title={
        <React.Fragment>
          <Trans>Education</Trans> <IndexBadge>{index + 1}</IndexBadge>
        </React.Fragment>
      }
      onRemove={onDelete ? () => onDelete(index) : undefined}
    >
      <FormGrid>
        <FormCol>
          <Field
            name={`${name}.institution`}
            component={TextFieldWrapper}
            label={<Trans>College / institution</Trans>}
          />
        </FormCol>
        <FormCol>
          <Field
            name={`${name}.degree`}
            component={SelectWrapper}
            label={<Trans>Degree</Trans>}
            parse={val => val && val.value}
            format={value => options.find(item => item.value === value)}
            options={options}
          />
        </FormCol>
        <FormCol>
          <FileUploaderField
            label={<Trans>Picture / scan</Trans>}
            name={`${name}.files`}
          />
        </FormCol>
      </FormGrid>
    </DocumentCard>
  );
}

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: flex-start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FormCol = styled.div`
  width: 100%;
  min-width: 0;
`;

FieldsetEducation.propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  index: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  onDelete: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
};

FieldsetEducation.defaultProps = {
  options: [],
};
